import React from 'react';
import PropTypes from 'prop-types'; // 👈 Import added

const CategoryTabs = ({ categories, activeTab, onTabClick }) => (
    <ul className="tabs owl-carousel pos-category5 owl-loaded owl-drag" style={{ display: 'block', height: '100%', overflow: 'hidden' }}>
        <div className="owl-stage-outer">
            <div className="owl-stage" style={{ transform: 'translate3d(0px, 0px, 0px)', transition: 'all', width: '109px' }}>
                <div className="owl-item" style={{ width: '15.533px' }}>
                    <li id="all" className={activeTab === 'all' ? 'active' : ''} onClick={() => onTabClick('all')}>
                        <a href="#" aria-label="All categories">
                            <img src="assets/img/products/pos-product-01.png" alt="Categories" />
                        </a>
                        <h6><a href="#">All</a></h6>
                    </li>
                </div>
                {categories.map(category => (
                    <div key={category.id} className="owl-item" style={{ width: '15.533px' }}>
                        <li
                            id={category.name.toLowerCase()}
                            className={activeTab === category.name.toLowerCase() ? 'active' : ''}
                            onClick={() => onTabClick(category.name.toLowerCase())}
                        >
                            <a href="#" aria-label={`Select category ${category.name}`}>
                                <img src={`/assets/img/products/pos-product-01.png`} alt="Categories" />
                            </a>
                            <h6><a href="#">{category.name}</a></h6>
                        </li>
                    </div>
                ))}
            </div>
        </div>
    </ul>
);

// ✅ Add PropTypes
CategoryTabs.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    activeTab: PropTypes.string.isRequired,
    onTabClick: PropTypes.func.isRequired,
};

export default CategoryTabs;
